/**
 * The checkbox's accessibility role on each platform.
 *
 * iOS has no checkbox trait, and React Native maps `checkbox` there to NO trait
 * at all — only the value "checkbox, unchecked". The box then reached VoiceOver
 * and XCTest as an inert `Other` element that nothing marks as pressable: an
 * agent-device `find … click` on a to-do's box matched nothing (EAS cloud run
 * 41149870451, 2026-10-31), while the ⋯ beside it, a `Button`, was found. On
 * iOS it is a button, and the checked state still rides the value ("checked" /
 * "unchecked") from `accessibilityState`. Android maps `checkbox` to its own
 * CheckBox class, and web keeps `role="checkbox"` with `aria-checked`.
 */
export function checkboxAccessibilityRole(os: string): 'button' | 'checkbox' {
  return os === 'ios' ? 'button' : 'checkbox';
}
